import React from 'react';
import './../styles/app.css';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    // Suppression du style inline 'background' du <footer> car il est déjà dans app.css
    <footer className="footer"> 
      <div>
        <Link to="/contact" className="footer-link">
          Nous contacter
        </Link>
        <span className="footer-separator">|</span>
        <Link to="/cgu" className="footer-link">
          CGU
        </Link>
        <span className="footer-separator">|</span>
        <Link to="/cgv" className="footer-link">
          CGV
        </Link>
      </div>
      <div style={{ marginTop: '5px' }}>
        © 2025 Gioco-Mortale. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;